@if (!successfulSignup) {
  <div class="modal-header">
    <h4 class="modal-title">{{ "login.create_account" | translate }}</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="300px" spinnerName="simpleSignupLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      <div class="col-md-12 m-b-20">
        <div class="text-center c-lblue">
          <div><img [src]="appService.systemTheme == 'dark' ? './assets/images/presonus_logo.png' : './assets/images/presonus_logo_black.png'" style="width: 150px; margin-bottom: 30px" /></div>
          @if (displayedAuthSection == "Create Account") {
            To continue, please sign up for a free PreSonus account. Once created, we will drop you right where you left off.
            <div class="m-t-10 m-b-10">
              You can use this account to comment on shared files, collaborate with {{ env.studioOnePlusBrandName }} members, and manage your PreSonus hardware and software products.
            </div>
          }
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button class="brand-btn-reverse" style="min-width: 150px" (click)="appService.redirectToConnect(true)">Log In</button>
      &nbsp;&nbsp;&nbsp;
      <button class="brand-btn-reverse" style="min-width: 150px" (click)="appService.redirectToConnect(true, false, false, 'join')">Create Account</button>
    </div>
  }
</div>
